module.exports = __webpack_public_path__ + "components/flag/static/square/vc-7fccf352d99a3ae594661b193f72d8f4.svg";